import React, { ReactNode } from 'react';
import classNames from 'classnames';

type Props = {
  to: string;
  children: ReactNode;
  className?: string;
  target?: string;
};

const ExternalLink = ({ to, children, className, target, ...rest }: Props) => (
  <a href={to} rel="noreferrer" target={target ?? '_blank'} className={classNames(className)} {...rest}>
    {children}
  </a>
);

export default ExternalLink;
